import { render } from "./Criteria.vue?vue&type=template&id=be6982d2"
import script from "./Criteria.vue?vue&type=script&lang=js"
export * from "./Criteria.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__